export const pagination = {
  showingOfTemplate: "Showing ${start}-${end} of ${max}",
};
